<template>
	<div class="header">
		<div class="static-col static-row">Reservas</div>
		<div
			v-for="(day, indexDay) in dateArray"
			:key="indexDay"
		>{{day}}</div>
	</div>
</template>

<script>
import { differenceInDays, addDays, format } from 'date-fns';

function dateArray() {
	const numberOfDays = differenceInDays(this.endDay, this.initDay);
	const dateRange = [];
	for (let i = 0; i < numberOfDays; i += 1) {
		const date = addDays(this.initDay, i);
		dateRange.push(format(date, 'ddd D'));
	}
	return dateRange;
}

export default {
	name: 'date-header',
	computed: {
		dateArray,
	},
	props: {
		initDay: {
			default: '',
			type: String,
		},
		endDay: {
			default: '',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.header {
	color: white;
	display: flex;
	height: 23px;
	width: fit-content;
}

.header > div {
	background-color: map-get($colors, header-dark);
	width: $widthItemDay;
}

.static-col {
	left: 0;
	position: sticky;
}

.static-row {
	top: 0;
}
</style>




// WEBPACK FOOTER //
// DateHeader.vue?7af4f854